// iter360c — Friendly, unique, deterministic invoice number (option 1A).
// Derived from the invoice type + its stable record id, so it works
// instantly on every existing and future invoice with no migration and no
// DB writes. Example: INV-TRN-EDDD05B8, INV-ENR-6B14907A.

const PREFIX_BY_TYPE = {
  enrollment: 'ENR',
  monthly: 'ENR',
  monthly_invoice: 'ENR',
  tournament: 'TRN',
  tournament_registration: 'TRN',
  small_group: 'SGP',
  small_group_invoice: 'SGP',
  lane_booking: 'LNB',
  lane: 'LNB',
  manual: 'MAN',
  manual_invoice: 'MAN',
  camp: 'CMP',
  camp_registration: 'CMP',
  uniform: 'UNI',
  uniform_order: 'UNI',
};

// The stable per-invoice identity. For enrollment rows the monthly-invoice
// id is the true per-cycle identity; everything else uses the row id.
export function invoiceIdentity(invoice) {
  if (!invoice) return '';
  const type = String(invoice.type || invoice.entity_type || '').toLowerCase();
  if (type.startsWith('enroll') || type === 'monthly' || type === 'monthly_invoice') {
    return String(invoice.monthly_invoice_id || invoice.id || '');
  }
  return String(invoice.id || invoice.entity_id || '');
}

export function friendlyInvoiceNumber(invoice) {
  if (!invoice) return '';
  // Honour an explicitly stored number if the backend ever sets one.
  if (invoice.invoice_number) return String(invoice.invoice_number);
  const type = String(invoice.type || invoice.entity_type || '').toLowerCase();
  const prefix = PREFIX_BY_TYPE[type] || 'INV';
  const short = invoiceIdentity(invoice).replace(/-/g, '').slice(0, 8).toUpperCase();
  return short ? `INV-${prefix}-${short}` : '';
}
